import * as ImagePicker from "expo-image-picker";
import * as Permissions from "expo-permissions";
import * as firebase from "firebase";
import React from "react";
import {
  ActivityIndicator,
  Clipboard,
  Image,
  Share,
  StatusBar,
  StyleSheet,
  Text,
  View,
  LogBox,
} from "react-native";
import uuid from "uuid";
import { auth } from "firebase";
import Ionicons from "@expo/vector-icons/Ionicons";
import { BottomSheet, Button, ListItem } from "react-native-elements";

import { Avatar, Accessory, Input } from "react-native-elements";
import { TouchableOpacity } from "react-native";

// const firebaseConfig = {
//   apiKey: 'AIzaSyAlZruO2T_JNOWn4ysfX6AryR6Dzm_VVaA',
//   authDomain: 'blobtest-36ff6.firebaseapp.com',
//   databaseURL: 'https://blobtest-36ff6.firebaseio.com',
//   storageBucket: 'blobtest-36ff6.appspot.com',
//   messagingSenderId: '506017999540',
// };

// if (!firebase.apps.length) {
//   firebase.initializeApp(firebaseConfig);
// }

// Firebase sets some timeers for a long period, which will trigger some warnings. Let's turn that off for this example
//LogBox.ignoreAllLogs(); //Ignore all log notifications

export default class App extends React.Component {
  state = {
    image: null,
    uploading: false,
    profileName: "",

    changeName: false,
    showBottomSheet: false,
  };

  async componentDidMount() {
    if (this.props.uid === auth().currentUser.uid) {
      await Permissions.askAsync(Permissions.CAMERA_ROLL);
      await Permissions.askAsync(Permissions.CAMERA);
      this.setState({
        profileName: auth().currentUser.displayName,
      });
    } else {
      firebase
        .database()
        .ref("profile/" + this.props.uid)
        .once("value")
        .then((snapshot) => {
          const vals = snapshot.val();

          if (vals === undefined || vals === null) {
            //should newver be this case

            this.setState({
              profileName: "someone",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png",
            });
          } else {
            this.setState({
              profileName: vals.displayName,
              image: vals.profilePic,
            });
          }

          return vals;
        });
    }
  }

  render() {
    let { image } = this.state;
    const list = [
      {
        title: "🖼️ Choose from your photos",
        onPress: this._pickImage,
      },
      { onPress: this._takePhoto, title: "📷 Take a photo" },

      {
        onPress: () =>
          this.setState({
            changeName: !this.state.changeName,
            showBottomSheet: false,
          }),
        title: "📛 Edit name",
      },

      {
        title: "❌ Cancel",
        containerStyle: { borderWidth: 3 },
        onPress: () =>
          this.setState({
            showBottomSheet: false,
          }),
      },
    ];

    return (
      <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
        {!!image && (
          <Text
            style={{
              fontSize: 20,
              marginBottom: 20,
              textAlign: "center",
              marginHorizontal: 15,
            }}
          >
            Upload Image
          </Text>
        )}
        <TouchableOpacity
          onPress={() => {
            this.props.navigation.navigate("FullImage", {
              profileUrl:
                this.props.uid === auth().currentUser.uid
                  ? auth().currentUser.photoURL
                  : this.state.image,
              name:this.state.profileName,

            });
          }}
        >
          {auth().currentUser.photoURL !== "" ? (
            <Avatar
              source={{
                uri:
                  this.props.uid === auth().currentUser.uid
                    ? auth().currentUser.photoURL
                    : this.state.image,
              }}
              size="xlarge"
              rounded
            ></Avatar>
          ) : null}
        </TouchableOpacity>
        <BottomSheet
          isVisible={this.state.showBottomSheet}
          containerStyle={{ backgroundColor: "rgba(0.5, 0.25, 0, 0.2)" }}
        >
          {list.map((l, i) => (
            <ListItem
              key={i}
              containerStyle={l.containerStyle}
              onPress={l.onPress}
            >
              <ListItem.Content>
                <ListItem.Title style={l.titleStyle}>{l.title}</ListItem.Title>
              </ListItem.Content>
            </ListItem>
          ))}
        </BottomSheet>

        {this.props.uid === auth().currentUser.uid ? (
          <Button
            title=""
            containerStyle={{
              position: "absolute",
              right: 0,
            }}
            type="clear"
            onPress={() => {
              this.setState({
                showBottomSheet: true,
              });
            }}
            icon={<Ionicons name="md-create" size={30} color="white" />}
          />
        ) : null}

        {this.state.changeName ? (
          <View>
            <Input
              value={this.state.profileName}
              style={{ color: "white" }}
              onChangeText={(value) => this.setState({ profileName: value })}
              containerStyle={{
                width: 200,
              }}
            />

            <Button
              onPress={async () => {
                const update = {
                  displayName: this.state.profileName,
                };

                firebase
                  .database()
                  .ref("profile/" + auth().currentUser.uid)
                  .update({
                    displayName: this.state.profileName,
                  });

                await auth().currentUser.updateProfile(update);
                this.setState({
                  changeName:!this.state.changeName
                })
              }}
              title=" ✔️"
              type="clear"

            />
             <Button
              onPress={ () => {


                this.setState({
                  changeName:false,
                  profileName: auth().currentUser.displayName,

                })
              }}
              title=" ❌"
              type="clear"

            />
          </View>
        ) : (
          <Text
            style={{
              color: "white",
              fontSize: 25,
              marginTop: 15,
            }}
          >
            {this.state.profileName}
          </Text>
        )}
        {/* <Button
          onPress={this._pickImage}
          title="Pick an image from camera roll"
        />
        <Button onPress={this._takePhoto} title="Take a photo" /> */}
        {/* {this._maybeRenderImage()} */}
        {this._maybeRenderUploadingOverlay()}
        <StatusBar barStyle="default" />
      </View>
    );
  }

  _maybeRenderUploadingOverlay = () => {
    if (this.state.uploading) {
      return (
        <View
          style={[
            StyleSheet.absoluteFill,
            {
              backgroundColor: "rgba(0,0,0,0.4)",
              alignItems: "center",
              justifyContent: "center",
            },
          ]}
        >
          <ActivityIndicator color="#fff" animating size="large" />
        </View>
      );
    }
  };

  _maybeRenderImage = () => {
    let { image } = this.state;
    if (!image) {
      return;
    }

    return (
      <View
        style={{
          marginTop: 30,
          width: 250,
          borderRadius: 3,
          elevation: 2,
        }}
      >
        <View
          style={{
            borderTopRightRadius: 3,
            borderTopLeftRadius: 3,
            shadowColor: "rgba(0,0,0,1)",
            shadowOpacity: 0.2,
            shadowOffset: { width: 4, height: 4 },
            shadowRadius: 5,
            overflow: "hidden",
          }}
        >
          <Image source={{ uri: image }} style={{ width: 250, height: 250 }} />
        </View>
        <Text
          onPress={this._copyToClipboard}
          onLongPress={this._share}
          style={{ paddingVertical: 10, paddingHorizontal: 10 }}
        >
          {image}
        </Text>
      </View>
    );
  };

  _share = () => {
    Share.share({
      message: this.state.image,
      title: "Check out this photo",
      url: this.state.image,
    });
  };

  _copyToClipboard = () => {
    Clipboard.setString(this.state.image);
    alert("Copied image URL to clipboard");
  };

  _takePhoto = async () => {
    let pickerResult = await ImagePicker.launchCameraAsync({
      allowsEditing: true,
      aspect: [4, 3],
    });

    this._handleImagePicked(pickerResult);
  };

  _pickImage = async () => {
    let pickerResult = await ImagePicker.launchImageLibraryAsync({
      allowsEditing: true,
      aspect: [4, 3],
    });

    this._handleImagePicked(pickerResult);
  };

  _handleImagePicked = async (pickerResult) => {
    try {
      this.setState({ uploading: true });

      if (!pickerResult.cancelled) {
        const uploadUrl = await uploadImageAsync(pickerResult.uri);
        const update = {
          // displayName: 'Alias',
          photoURL: uploadUrl,
        };

        firebase
          .database()
          .ref("profile/" + auth().currentUser.uid)
          .update({
            profilePic: uploadUrl,
          });

        await auth().currentUser.updateProfile(update);

        this.setState({ image: uploadUrl });
      }
    } catch (e) {
      console.log(e);
      alert("Upload failed, sorry :(");
    } finally {
      this.setState({ uploading: false });
    }
  };
}

async function uploadImageAsync(uri) {
  // Why are we using XMLHttpRequest? See:
  // https://github.com/expo/expo/issues/2402#issuecomment-443726662
  const blob = await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = function () {
      resolve(xhr.response);
    };
    xhr.onerror = function (e) {
      console.log(e);
      reject(new TypeError("Network request failed"));
    };
    xhr.responseType = "blob";
    xhr.open("GET", uri, true);
    xhr.send(null);
  });

  const ref = firebase
    .storage()
    .ref()
    .child("profiles/" + auth().currentUser.uid);
  // .child("profiles/" + uuid());

  const snapshot = await ref.put(blob);

  // We're done with the blob, close and release it
  blob.close();
  return await snapshot.ref.getDownloadURL();
}
